import React from 'react';
import memoizeOne from 'memoize-one';
import withFireUiAnalytics from '@atlassian/jira-analytics-web-react/src/components/with-fire-ui-analytics.tsx';
import FilterSearch from '@atlassian/jira-common-analytics-v2-wrapped-components/src/filter-search';
import type { FilterViewProps } from '@atlassian/jira-directory-base/src/model';
import ProjectPicker from '@atlassian/jira-project-picker';
import { connect } from '@atlassian/jira-react-redux';
import type { Filter as FilterType } from '../../../model';
import { getBaseUrl } from '../../../state/selectors/app';
import { getFilter, getSelectedProject, getSearchText } from '../../../state/selectors/query';
import type { State } from '../../../state/types';
import type { FilterSearchProps, ProjectSearchProps } from './types';
import Filter from './view';

const FilterSearchWithAnalytics = withFireUiAnalytics({
	onChange: 'filterSearch',
})(FilterSearch);
const ProjectTypePickerWithAnalytics = withFireUiAnalytics({
	onChange: 'projectSearch',
})(ProjectPicker);

const renderFilterSearch = (state: State) => (props: FilterSearchProps) => (
	<FilterSearchWithAnalytics {...props} value={getSearchText(state)} />
);

const renderProjectPicker = (state: State) => (props: ProjectSearchProps) => (
	<ProjectTypePickerWithAnalytics
		{...props}
		selectedProject={getSelectedProject(state)}
		baseUrl={getBaseUrl(state)}
		inputId="board-filters-project-picker-select"
	/>
);

const mapStateToPropsFactory = () => {
	const renderFilterSearchFactory = memoizeOne(renderFilterSearch);
	const renderProjectPickerFactory = memoizeOne(renderProjectPicker);
	return (state: State, ownProps: FilterViewProps<FilterType>) => ({
		value: getFilter(state),
		onChange: ownProps.onFilter,
		renderFilterSearch: renderFilterSearchFactory(state),
		renderProjectPicker: renderProjectPickerFactory(state),
	});
};

export default connect(mapStateToPropsFactory, {})(Filter);
